/**
 * @generated SignedSource<<a21a486e33b478f88214368eebf9408c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignTxnStakeholderInputObject = {
  name?: string | null | undefined;
  stakeholderId?: string | null | undefined;
  txnId: string;
};
export type assignCell_AssignTxnStakeholderMutation$variables = {
  input: AssignTxnStakeholderInputObject;
};
export type assignCell_AssignTxnStakeholderMutation$data = {
  readonly assignTxnStakeholder: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
};
export type assignCell_AssignTxnStakeholderMutation = {
  response: assignCell_AssignTxnStakeholderMutation$data;
  variables: assignCell_AssignTxnStakeholderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "assignCell_AssignTxnStakeholderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignTxnStakeholderMutationPayload",
        "kind": "LinkedField",
        "name": "assignTxnStakeholder",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assignCell_AssignTxnStakeholderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignTxnStakeholderMutationPayload",
        "kind": "LinkedField",
        "name": "assignTxnStakeholder",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ff666285c2a409bd7ba17487b153707a",
    "id": null,
    "metadata": {},
    "name": "assignCell_AssignTxnStakeholderMutation",
    "operationKind": "mutation",
    "text": "mutation assignCell_AssignTxnStakeholderMutation(\n  $input: AssignTxnStakeholderInputObject!\n) {\n  assignTxnStakeholder(input: $input) {\n    stakeholder {\n      id\n      name\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8850fb908beb915ed1d3bf6fb675a4b6";

export default node;
